// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"1df55b24","264":"6b6e70e4","395":"da14fdf0","485":"bce1eb3d","560":"526a8b6e","897":"6e526978"}[chunkId] + ".chunk.js";
};